var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('SideMenuComponent'),_c('div',{staticClass:"sub-ctn"},[_c('TopBarComponent'),_c('div',{staticClass:"view-container"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }